<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thêm mới nguồn hình thành tài sản</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left"
                                              label-class="required">
                                    <div class="col-md-6 no-padding">
                                        <b-form-input type="text" style="display: none"
                                                      aria-describedby="unitLevelFeedback"
                                                      v-model="$v.assetSource.syncSourceType.$model"
                                                      :state="$v.assetSource.syncSourceType.$dirty ? !$v.assetSource.syncSourceType.$error : null"></b-form-input>
                                        <sync-data-source :cached="true" v-model="assetSource.syncSourceType" :excluded="[2]"></sync-data-source>
                                        <b-form-invalid-feedback>
                                            Vui lòng chọn phần mềm đồng bộ
                                        </b-form-invalid-feedback>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Nguồn hình thành cha:"
                                              label-for="input-parentname"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect id="input-parentname" class="col-md-6 no-padding"
                                                ref="assetSourceTree"
                                                v-model="assetSource.parentId"
                                                :max-height="390"
                                                placeholder="Nhập nguồn hình thành"
                                                :options="assetSourceTree" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Mã nguồn hình thành tài sản: "
                                              label-for="input-code"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-class="required"
                                              label-align="left">
                                    <b-form-input type="text" id="input-code"
                                                  class="col-md-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.assetSource.code.$model"
                                                  :state="($v.assetSource.code.$dirty? !$v.assetSource.code.$error : null) && ($v.codeUnique.$dirty? !$v.codeUnique.$error : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback" v-if="$v.assetSource.code.$error">
                                        Vui lòng nhập mã
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback id="existingCodeFeedback" v-if="!$v.assetSource.code.$error && ($v.codeUnique.$error)">
                                        Mã nguồn hình thành tài sản đã tồn tại
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Tên nguồn hình thành tài sản: "
                                              label-for="input-name"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-class="required"
                                              label-align="left">
                                    <b-form-input type="text" id="input-name"
                                                  class="col-md-6"
                                                  aria-describedby="nameFeedback"
                                                  v-model="$v.assetSource.name.$model"
                                                  :state="$v.assetSource.name.$dirty? !$v.assetSource.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="nameFeedback">
                                        Vui lòng nhập tên
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Loại tài sản áp dụng: "
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect v-model="assetSource.appliedAssetTypeGroupIds"
                                                multiple
                                                class="no-padding col-md-6"
                                                placeholder="--- Tất cả ---"
                                                :options="assetTypeGroups" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Nhóm nguồn gốc tài sản: "
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-md-6 col-6 p-l-r-0">
                                        <select2 :options="listAssetSourceGroup"
                                                 v-model="assetSource.assetSourceGroup"
                                                 allowClear="true"
                                                 placeholder="--- Tất cả ---"></select2>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="" :label-cols="4" label-cols-md="3">
                                    <b-button type="submit" variant="primary">Lưu</b-button>
                                    <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'CreateAssetSource',
        mixins: [validationMixin],
        data() {
            return {
                codeUnique: 'ok',
                assetSource: {
                    parentId: null,
                    name: null,
                    code: null,
                    appliedAssetTypeGroupIds: [],
                    assetSourceGroup: null,
                    syncSourceType: null,
                },
                editing: false
            }
        },
        computed: {
            ...mapState({
                assetSourceTree: (state, getters) => getters.assetSourceTree,
                assetTypeGroups: (state, getters) => getters.assetTypeGroupTree,
                listAssetSourceGroup: (state, getters) => state.common.listAssetSourceGroup
            })
        },
        watch: {
            'assetSource.parentId'(newVal) {
                var codeParent = this.$store.getters.getAssetSourceTreeCode(newVal);
                this.assetSource.code = codeParent;
            },
        },
        validations: {
            assetSource: {
                code: { required },
                name: { required },
                syncSourceType: { required },
            },
            codeUnique: { required }
        },
        created() {

        },
        methods: {
            cancel() {
                this.$router.push({ path: '.' });
            },
            save() {
                this.$v.$touch();
                var vm = this;
                if (vm.assetSource.code != null && vm.assetSource.code != '') {
                    vm.$services.get(`master-data/existing-asset-sources-code`, { id: vm.assetSource.id || '', code: vm.assetSource.code || '' }).done(returnData => {
                        if (!returnData) {
                            vm.codeUnique = "required";
                            if (!vm.$v.$invalid) {
                                vm.$services.post('master-data/asset-sources', vm.assetSource).done((id) => {
                                    vm.$toastr.s('Tạo mới nguồn hình thành tài sản thành công');
                                    vm.$store.dispatch("loadAssetSources");
                                    vm.cancel();
                                });
                            }
                        }
                        else {
                            vm.codeUnique = "";
                        }
                    });
                }
            },
        }
    }
</script>
<style scoped>
</style>
